/**
 * Centralized environment variables (`VITE_*`).
 *
 * Each value must use a static `process.env.VITE_*` reference so Vite can
 * inline it at build time via `define` in vite.config.mjs. Dynamic lookups
 * like `process.env[key]` are not replaced and end up empty in production builds.
 */

export const env = Object.freeze({
    environment: process.env.VITE_APP_ENVIRONMENT ?? '',
    apiUrl: process.env.VITE_APP_API_URL ?? '',
    apiUrlLocal: process.env.VITE_APP_API_URL_LOCAL ?? '',
    mapboxApiKey: process.env.VITE_APP_MAPBOX_API_KEY ?? '',
    apiSocketUrl: process.env.VITE_APP_API_SOCKET_URL ?? '',
    apiSocketUrlLocal: process.env.VITE_APP_API_SOCKET_URL_LOCAL ?? '',
    googleAnalyticsKey: process.env.VITE_APP_GOOGLE_ANALYTICS_KEY ?? '',
    auth0Domain: process.env.VITE_APP_AUTH0_DOMAIN ?? '',
    auth0ClientId: process.env.VITE_APP_AUTH0_CLIENTID ?? '',
    auth0Audience: process.env.VITE_APP_AUTH0_AUDIENCE ?? '',
    clarityProjectId: process.env.VITE_CLARITY_PROJECT_ID ?? '',
    launchdarklyClientSideId: process.env.VITE_APP_LAUNCHDARKLY_CLIENT_SIDE_ID ?? '',
    cloudwatchRumApplicationId: process.env.VITE_APP_CLOUDWATCH_RUM_APPLICATION_ID ?? '',
    cloudwatchRumIdentityPoolId: process.env.VITE_APP_CLOUDWATCH_RUM_IDENTITY_POOL_ID ?? '',
    cloudwatchRumRegion: process.env.VITE_APP_CLOUDWATCH_RUM_REGION ?? 'us-west-2',
    /** Immutable CI build id (`<short-sha>-<pipeline-id>`); empty for local dev. */
    buildId: process.env.VITE_APP_BUILD_ID ?? '',
    /** OTLP resource `service.name` (PRD-3050). */
    otelServiceName: process.env.VITE_OTEL_SERVICE_NAME ?? 'portal-web',
    /** OTLP resource `service.namespace` (PRD-3050). */
    otelServiceNamespace: process.env.VITE_OTEL_SERVICE_NAMESPACE ?? 'portal',
});

export const isProduction = env.environment === 'production';
export const isStage = env.environment === 'stage';
